import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const legendLabelColor = '#777c83'


const SankeyChart = ({
    chartData = [],
    chartLabel,
    fieldsLabel = "",
    purpose = "",
    legendLabel = "Task Flow",
}) => {

    const dummyData = [
        {
            source: "Development",
            target: "QA",
            value: 42,
            avgSlippage: 18.4,
            totalEstimateHours: 156,
        },
        {
            source: "Development",
            target: "DevOps",
            value: 12,
            avgSlippage: 9.8,
            totalEstimateHours: 41,
        },
    ];

    const graphData =
        chartData?.length > 0
            ? chartData
            : dummyData;

    // Always use first source like mockup
    const rootSource = graphData[0]?.source || "Development";

    const nodes = [];

    nodes.push({
        name: rootSource,
        itemStyle: {
            color: "#3B82F6",
        },
    });

    graphData.forEach(item => {

        if (
            !nodes.find(n => n.name === item.target)
        ) {
            nodes.push({
                name: item.target,

                itemStyle: {
                    color:
                        item.target === "QA"
                            ? "#10B981"
                            : "#EF4444",
                },
            });
        }

    });

    const links = graphData.map(item => ({
        source: rootSource,
        target: item.target,
        value: item.value,
        avgSlippage: item.avgSlippage,
        totalEstimateHours: item.totalEstimateHours,
    }));

    const option = {

        tooltip: {
            trigger: "item",
            formatter(params) {
                let html = "";
                if (purpose) {
                    html += `<b>Purpose</b><br/>${purpose}<br/><br/>`;
                }
                if (params.dataType === "edge") {

                    html += `
                <b>${params.data.source}</b> ➜ <b>${params.data.target}</b><br/>
                <b>Tasks</b> : ${params.data.value}<br/>
                <b>Avg Slippage</b> : ${params.data.avgSlippage}<br/>
                <b>Estimate Hours</b> : ${params.data.totalEstimateHours}
            `;

                    return html;
                }

                return html + `<b>${params.name}</b>`;
            },
        },

        legend: {
            show: true,
            top: 5,
            left: "center",
            data: [legendLabel],
             textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
        },

        series: [
            {
                name: legendLabel,
                type: "sankey",
                left: "8%",
                right: "8%",
                top: "10%",
                bottom: "10%",
                nodeAlign: "left",
                layoutIterations: 0,
                draggable: false,
                nodeWidth: 48,
                nodeGap: 45,
                emphasis: {
                    focus: "adjacency",
                },

                label: {
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 14,
                    position: "inside",
                    show: false,
                },

                lineStyle: {
                    color: "#9CC4FA",
                    opacity: 0.65,
                    curveness: 0.35,
                },

                data: nodes,

                links: links,
            },
        ],
    };

    return (
        <ChartCard
            title={chartLabel}
            height={420}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default SankeyChart;